import { useEffect } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export default function InvalidTokenPage() {
  const navigate = useNavigate();
  const location = useLocation();



  // Determine context based on query or pathname
  const path = location.pathname;
  const isReset = path.includes("reset-password");
  const isInvite = path.includes("invite");
  const isVerify = path.includes("verify");

  useEffect(() => {
    // Only run once on mount
    const isValidAction = isReset || isInvite || isVerify;

    if (!isValidAction) {
      navigate("/404", { replace: true });
    }
  }, [navigate, isReset, isInvite, isVerify]);


  let title = "Invalid or Expired Link";
  let message =
    "The link you clicked is either invalid, expired, or already used.";
  let buttonLabel = "";
  let buttonAction = () => navigate("/login");

  if (isReset) {
    title = "Invalid or Expired Reset Link";
    message =
      "The password reset link you clicked is either invalid or has expired. Please request a new one to continue.";
    buttonLabel = "Request New Reset Link";
    buttonAction = () => navigate("/forgot-password");
  } else if (isInvite) {
    title = "Invalid or Expired Invite Link";
    message =
      "The invitation link you clicked is invalid or has expired. Please contact your admin to request a new invitation.";
    buttonLabel = "";
    buttonAction = () => navigate("/login");
  } else if (isVerify) {
    title = "Invalid or Expired Verification Link";
    message =
      "The verification link is invalid or expired. Please request a new one or log in if already verified.";
    buttonLabel = "Back to Login";
    buttonAction = () => navigate("/login");
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-lg text-center">
        <div className="flex justify-center mb-4">
          <span className="text-red-500 text-5xl">{FaExclamationTriangle({})}</span>
        </div>

        <h1 className="text-2xl font-semibold text-gray-800 mb-2">{title}</h1>

        <p className="text-gray-600 mb-6">{message}</p>

        {buttonLabel && (
          <button
            onClick={buttonAction}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition"
          >
            {buttonLabel}
          </button>
        )}

        {!isInvite && <div className="mt-4">
          <p
            onClick={() => navigate("/login")}
            className="text-blue-600 hover:underline text-sm cursor-pointer"
          >
            Back to Login
          </p>
        </div>}
      </div>
    </div>
  );
}
